// extracted by mini-css-extract-plugin
export var close = "register-module--close--92d68";
export var content = "register-module--content--a1cb0";
export var cross = "register-module--cross--9caa6";
export var form = "register-module--form--34af7";
export var icon = "register-module--icon--d32fc";
export var image = "register-module--image--02f9e";
export var modal = "register-module--modal--1e21a";
export var overlay = "register-module--overlay--90cb1";
export var text = "register-module--text--33605";
export var title = "register-module--title--03a09";